module.exports = __webpack_public_path__ + "static/media/achievement-10k-day.44466495.svg";